import { render, staticRenderFns } from "./omt-h3.vue?vue&type=template&id=5e262a85&scoped=true&"
var script = {}
import style0 from "./omt-h3.vue?vue&type=style&index=0&id=5e262a85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e262a85",
  null
  
)

export default component.exports